module.exports = __webpack_public_path__ + "static/media/g_icon.09aea0f5.svg";